import { Maybe } from 'maybe-not';
import { sendMessage } from 'q2-tecton-common/lib/utility/message-bus';
import { IPlatformAlertOptions, PlatformAlertType } from '../types';

export default function showAlert(platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('sendAlert') && !platformCapabilities.has('sendAlertWithError')) {
        return;
    }

    return function(alertOptions: IPlatformAlertOptions<PlatformAlertType>): void {
        sendMessage(`sendAlert`, Maybe.just(alertOptions).map(JSON.stringify));
    };
}
